import { FILTER_FIELDS } from '@constants';
import theme from 'config/theme';

const TRADE_TICKETS_STAGES_ENUM = {
  LEAD_IN: 1,
  TEL_CONTACT: 2,
  CAR_DATA_UPLOADED: 3,
  REVIEW: 4,
  DEALER_PENDING: 5,
  DEALER_APPROVED: 6,
  REJECTED: 7,
  CUSTOMER_PENDING: 8,
  CUSTOMER_APPROVED: 9,
  INSPECTION_BOOKED: 10,
  DEALER_COUNTER_OFFER: 11,
  APPROVED: 12,
  SOURCING_APPROVED: 13,
  FINANCE_APPROVED: 14,
  TRANSFER_OWNERSHIP: 15,
  DONE: 16,
  CANCELED: 17,
};

export const TRADE_TICKETS_STAGES_NAMES = {
  LeadIn: {
    label: 'Lead In',
    value: TRADE_TICKETS_STAGES_ENUM.LEAD_IN,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  TelContact: {
    label: 'Tel contact',
    value: TRADE_TICKETS_STAGES_ENUM.TEL_CONTACT,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  CarDataUploaded: {
    label: 'Car data uploaded',
    value: TRADE_TICKETS_STAGES_ENUM.CAR_DATA_UPLOADED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  Review: {
    label: 'Review',
    value: TRADE_TICKETS_STAGES_ENUM.REVIEW,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  DealerPending: {
    label: 'Dealer Pending',
    value: TRADE_TICKETS_STAGES_ENUM.DEALER_PENDING,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  DealerApproved: {
    label: 'Dealer Approved',
    value: TRADE_TICKETS_STAGES_ENUM.DEALER_APPROVED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  Rejected: {
    label: 'Rejected',
    value: TRADE_TICKETS_STAGES_ENUM.REJECTED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  CustomerPending: {
    label: 'Customer Pending',
    value: TRADE_TICKETS_STAGES_ENUM.CUSTOMER_PENDING,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  CustomerApproved: {
    label: 'Customer Approved',
    value: TRADE_TICKETS_STAGES_ENUM.CUSTOMER_APPROVED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  InspectionBooked: {
    label: 'Inspection Booked',
    value: TRADE_TICKETS_STAGES_ENUM.INSPECTION_BOOKED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  DealerCounterOffer: {
    label: 'Dealer Counter Offer',
    value: TRADE_TICKETS_STAGES_ENUM.DEALER_COUNTER_OFFER,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  Approved: {
    label: 'Approved',
    value: TRADE_TICKETS_STAGES_ENUM.APPROVED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  SourcingApproved: {
    label: 'Sourcing Approved',
    value: TRADE_TICKETS_STAGES_ENUM.SOURCING_APPROVED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  FinanceApproved: {
    label: 'Finance Approved',
    value: TRADE_TICKETS_STAGES_ENUM.FINANCE_APPROVED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  TransferOwnership: {
    label: 'Transfer Ownership',
    value: TRADE_TICKETS_STAGES_ENUM.TRANSFER_OWNERSHIP,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  Done: {
    label: 'Done',
    value: TRADE_TICKETS_STAGES_ENUM.DONE,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  Canceled: {
    label: 'Canceled',
    value: TRADE_TICKETS_STAGES_ENUM.CANCELED,
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
};

export const TRADE_TICKETS_STAGES_ORDER = [
  'LeadIn',
  'TelContact',
  'CarDataUploaded',
  'Review',
  'DealerPending',
  'DealerApproved',
  'Rejected',
  'CustomerPending',
  'CustomerApproved',
  'InspectionBooked',
  'DealerCounterOffer',
  'Approved',
  'SourcingApproved',
  'FinanceApproved',
  'TransferOwnership',
  'Done',
  'Canceled',
];

export const TRADE_TICKETS_CONTRACT_PERIODS = {
  12: { label: '12 months' },
  24: { label: '24 months' },
  36: { label: '36 months' },
};

export const TRADE_TICKETS_PAGE_SIZE = 100;

export const TRADE_TICKETS_EXPORT_LIMIT = 100000;

export const tradeTicketsFields = {
  'customFields.createdAt': {
    ...FILTER_FIELDS.DateRange,
    label: 'Created At',
  },
};

export const VEHICLE_CONDITIONS = [
  {
    label: 'Bad',
    value: 'Bad',
  },
  {
    label: 'Fair',
    value: 'Fair',
  },
  {
    label: 'Good',
    value: 'Good',
  },
  {
    label: 'Like New',
    value: 'LikeNew',
  },
];

export const MECHANICAL_CONDITIONS = [
  {
    label: 'Bad',
    value: 'Bad',
  },
  {
    label: 'Fair',
    value: 'Fair',
  },
  {
    label: 'Good',
    value: 'Good',
  },
  {
    label: 'Like New',
    value: 'LikeNew',
  },
];
export const TIRE_CONDITIONS = [
  {
    label: 'Bad',
    value: 'Bad',
  },
  {
    label: 'Fair',
    value: 'Fair',
  },
  {
    label: 'Good',
    value: 'Good',
  },
  {
    label: 'Like New',
    value: 'LikeNew',
  },
];

// TODO: update the custom fields
export const TRADE_TICKETS_FIELD_NAMES = {
  assignee: 'Assignee',
  status: 'status',
  description: 'description',
  arnmTicket: 'AR&M Ticket',
  carId: 'car id',
  pipedriveId: 'pipedrive Id',
  subscriptionId: 'subscription Id',
  title: 'title',
  userEmail: 'user Email',
  userFirstName: 'user Firstname',
  userId: 'user Id',
  userLastName: 'user Lastname',
  vehicleDescription: 'vehicle Description',
  vehicleImage: 'vehicle Image',
  vehiclePlate: 'vehicle Plate',
  vehicleVin: 'vehicle Vin',
  board_id: 'board',
};

export const TRADE_TICKETS_REASONS_OF_REJECTION = [
  {
    label: 'Customer Rejected (Sale price too low)',
    value: 'CustomerRejectedLowPrice',
  },
  {
    label: 'Customer Rejected (Sold Vehicle elsewhere)',
    value: 'CustomerRejectedSoldVehicle',
  },
  {
    label: 'Customer Rejected (Does not want to sell)',
    value: 'CustomerRejectedNotSell',
  },
  {
    label: 'Dealer Rejected (Sale price too high)',
    value: 'DealerRejectedHighPrice',
  },
  {
    label: 'Dealer Rejected (Vehicle Condition too bad)',
    value: 'DealerRejectedVehicleCondition',
  },
  {
    label: 'Legal Issues',
    value: 'LegalIssues',
  },
  {
    label: 'Other ',
    value: 'Other',
  },
];
